import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, LineClamp } from '../../../global/commonStyle';

interface Props {
  isActive?: boolean;
  forceHover?: boolean;
}

const ProjectName = styled.div<Props>`
  ${AlignCenter}
  cursor: pointer;
  padding: var(--space-5);
  gap: var(--space-11);
  border-radius: var(--border-radius-8);
  .project-title {
    span {
      border-radius: var(--border-radius-4);
      ${Typography.body_sm_semibold}
    }
  }
  &:hover {
    background-color: var(--background-hover-navbar);
  }
  ${mobile_xl(css`
    max-width: -webkit-fill-available;
    padding: var(--space-11) var(--space-8);
    gap: var(--space-8);
    .project-title {
      span {
        border-radius: var(--border-radius-6);
      }
    }
  `)}
  ${(props: Props) =>
    props.forceHover &&
    css`
      background-color: var(--background-active-navbar);
    `}
  ${(props: Props) =>
    props.isActive &&
    css`
      background-color: var(--background-active-navbar);
      &:hover {
        background-color: var(--background-active-navbar);
      }
    `}
`;

const ProjectTitle = styled.p`
  color: var(--text-primary);
  ${Typography.body_md};
  margin: var(--space-0);
  ${LineClamp(1)}
  word-break: break-all;
  ${mobile_xl(css`
    font-weight: 500;
  `)}
`;

export { ProjectName, ProjectTitle };
